module.exports = __webpack_public_path__ + "img/level-2.345e72dd.svg";